import Drawer from 'components/drawer/Drawer';
import ColorSelector from 'components/color-selector/ColorSelector';
class ProductColorSelector extends Drawer {
    constructor(el, options) {
        super(el, options);
        this.name = 'color-selector';
        this.params = {
            desktop: {
                axis: 'X',
                direction: 'reversed'
            },
            mobile: {
                axis: 'Y',
                direction: 'reversed'
            }
        };
    }
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            selector: ['.color-selector__products', ColorSelector]
        };
    }
    initialized() {
        super.initialized();
        this.el.parentElement.style.setProperty('--color-header-height', `${this.refs.colorSelectorHeader.offsetHeight}px`);
    }
}
export default ProductColorSelector;
